<template>
  <Layer v-model="layerStatus">
    <div :class="`layer-content ${type}`">
      <div class="layer-header">
        <span :class="['icon iconfont', config.icon]"></span>
        <span>{{config.header}}</span>
      </div>
      <div class="layer-desc">
        <p v-html="config.desc"></p>
      </div>
      <div :class="['layer-btn', config.btnClass]" @click="btnClk">{{config.btnText}}</div>
    </div>
  </Layer>
</template>
<script>
import Layer from './layer'
export default {
  name: '',
  props: ['type', 'value', 'desc', 'bText'],
  components: {Layer},
  data () {
    return {
      layerStatus: this.value
    }
  },
  computed: {
    config () {
      if (this.type === 'error') {
        return {
          icon: 'icon_warn',
          header: '激活失败',
          desc: this.desc || '激活失败，请重新尝试激活',
          btnText: this.bText|| '重试'
        }
      }
      return {
        icon: 'icon_radio',
        header: '激活成功',
        desc: `点击下方下载按钮<br />下载股拍APP，享受课程服务！`,
        btnText: this.bText || '下载股拍APP',
        btnClass: 'downloadButton'
      }
    }
  },
  methods: {
    btnClk () {
      this.$emit('sure')
    }
  },
  watch: {
    value () {
      this.layerStatus = this.value
    },
    layerStatus (v) {
      if (!v) {
        this.$emit('input', false)
      }
    }
  },
  created () {
  },
  mounted () {
  }
}
</script>
<style lang="stylus" type="text/stylus" scoped>
.layer-content
  height 2.01rem
  padding .16rem .1rem .24rem
  background #fff
  border-radius .12rem
.layer-header
  font-size .19rem
  line-height .24rem
  color #1a1a1a
  text-align center
  > .icon
    margin-right .04rem
    font-size .21rem
.layer-desc
  display flex
  align-items center
  justify-content center
  margin .21rem 0 .24rem
  height .48rem
  line-height .24rem
  font-size .17rem
  color #333
  text-align center
.layer-btn
  width 2.3rem
  height .44rem
  margin 0 auto
  text-align center
  line-height .44rem
  background #FFD500
  color #333
  font-size .16rem
  font-weight bold
  border-radius .22rem
.error
  .icon
    color #f33
.succ
  .icon
    color #4C97FF
</style>
